<template>
  <div class="tabs">
  <ObjectListTabs>
    <template slot-scope="{}">
      <b-nav-item :to="{name: (results ? 'discover-results' : 'discover')}">Discover</b-nav-item>
      <b-nav-item :to="{name: 'discover-genre'}">Genre</b-nav-item>
      <b-nav-item :to="{name: 'discover-mood'}">Mood</b-nav-item>
      <b-nav-item :to="{name: 'discover-instrument'}">Instrument</b-nav-item>
    </template>
  </ObjectListTabs>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  @include media-breakpoint-down(sm) {
    .tabs {
      margin-bottom: 1.5em;
    }
  }
</style>

<script>
import ObjectListTabs from '@/components/widgets/ObjectListTabs'

export default {
  name: 'DiscoverTabs',
  components: { ObjectListTabs },
  props: {
    results: Boolean
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/DiscoverTabs.vue